<template>
  <div class="country-box">
    <input
      class="input-element"
      type="text"
      v-model="query"
      @input="inputHander"
      maxlength="25"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import utils from '../../services/tools.js';
import FeedbackService from '../../services/feedbackService.js';
import toast from '../../services/toast.js';

const CountryDropdown = Vue.extend(require('./CountryDropdown.vue'));

export default {
  props: ['value', 'countryArr'],

  data() {
    return {
      query: '',
      currentValue: this.value,
      filterCountries: [],
      countryDropdown: null,
      countryArray: [],
      feedbackService: new FeedbackService(this.$http),
    };
  },

  methods: {
    valueInit() {
      this.countryArray.forEach((country) => {
        if (country.code === this.value) {
          this.query = country.name;
        }
      });
      this.$emit('input', this.value);
    },

    countryArrayInit() {
      const _this = this;
      this.feedbackService
        .getVisaCountryTotalQuery({})
        .then((data) => {
          data.body.body.page_data.forEach((country) => {
            _this.countryArray.push({
              code: parseInt(country.id),
              name: country.country,
            });
          });
          _this.valueInit();
        })
        .catch(() => {
          toast.show('获取国家列表失败');
        });
    },

    inputHander(e) {
      const query = this.query ? this.query.trim() : '';

      if (query !== '') {
        this.filterCountries = this.countryArray
          .filter((v) => v.name.indexOf(query) > -1)
          .slice(0, 10);

        if (!this.countryDropdown) {
          this.countryOpen(e.target);
        }
      } else {
        this.filterCountries = [];
      }
    },

    countryOpen(target) {
      const _this = this;
      const offsetTop = utils.getOffsetTop(target);

      this.countryDropdown = new CountryDropdown({
        el: document.createElement('div'),
        data: {
          offsetTop: offsetTop || 0,
        },
        computed: {
          query() {
            return _this.query;
          },
          filterCountries() {
            return _this.filterCountries;
          },
        },
        methods: {
          countrySelect: this.countrySelect,
        },
      });

      document.body.appendChild(this.countryDropdown.$el);
    },

    countryClose() {
      if (this.countryDropdown) {
        document.body.removeChild(this.countryDropdown.$el);
        this.countryDropdown = null;
      }
    },

    countrySelect(country) {
      this.currentValue = country ? country.code : '';
      this.query = country ? country.name : '';
      this.$emit('input', this.currentValue);
      this.countryClose();
    },

    outsideClick(e) {
      if (!this.countryDropdown) return;

      if (
        !this.$el.contains(e.target) &&
        !this.countryDropdown.$el.contains(e.target)
      ) {
        this.countrySelect('');
      }
    },
  },

  created() {
    this.countryArrayInit();
  },

  mounted() {
    document.removeEventListener('click', this.outsideClick);
    document.addEventListener('click', this.outsideClick);
  },
};
</script>

<style lang="less" scoped>
.country-box {
  width: 100%;
  position: relative;
  .input-element {
    width: 100%;
    border-radius: 0.03rem;
    border: 0.01rem solid #e9e9e9;
    height: 0.45rem;
    outline: none;
    box-sizing: border-box;
    font-size: 0.15rem;
    padding: 0.15rem 0.1rem;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
}
</style>
